module.exports = __webpack_public_path__ + "static/media/bubbles.431c23d7.png";